import { useState } from 'react';
import { PRESET_TICKERS, TICKERS_STORAGE_KEY } from '../utils/tickers';
import ChartWidget from '../components/ChartWidget';
import CapSeriesChart from '../components/CapSeriesChart';
import SectorSeriesChart from '../components/SectorSeriesChart';
import ContractChartWidget from '../components/ContractChartWidget';
import GenericOptionsWidget from '../components/GenericOptionsWidget';
import BestContractsWidget from '../components/BestContractsWidget';
import ContractStatsHistory from '../components/ContractStatsHistory';

export default function Options() {
  // Shared timeframe for SPY/stock chart + Cap Series chart
  const [tf, setTf] = useState('1m');

  // Symbol shown in the main candlestick chart (dropdown inside ChartWidget)
  const [chartSymbol, setChartSymbol] = useState('SPX');

  // Custom tickers — shared between ChartWidget dropdown and GenericOptionsWidget.
  // Stored once here so both components always see the same list.
  const [customTickers, setCustomTickers] = useState(() => {
    try { return JSON.parse(localStorage.getItem(TICKERS_STORAGE_KEY)) || []; }
    catch { return []; }
  });

  const allTickers = [...PRESET_TICKERS, ...customTickers.filter(t => !PRESET_TICKERS.includes(t))];

  const handleCustomTickersChange = (updated) => {
    setCustomTickers(updated);
    localStorage.setItem(TICKERS_STORAGE_KEY, JSON.stringify(updated));
  };

  // Selected contract for the contract chart (set by GenericOptionsWidget)
  const [selectedContract, setSelectedContract] = useState(null);

  return (
    <div>
      <ChartWidget
        tf={tf} setTf={setTf}
        symbol={chartSymbol} setSymbol={setChartSymbol}
        tickers={allTickers}
      />
      <CapSeriesChart tf={tf} setTf={setTf} />
      <SectorSeriesChart tf={tf} setTf={setTf} />
      <ContractChartWidget contract={selectedContract} />
      <GenericOptionsWidget
        onContractSelect={setSelectedContract}
        customTickers={customTickers}
        onCustomTickersChange={handleCustomTickersChange}
      />
      <BestContractsWidget onContractSelect={setSelectedContract} />
      <ContractStatsHistory />
    </div>
  );
}
